import { useState } from "react";
import { X, Flag } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ReportModal({ work, onClose }) {
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (reason.trim().length < 5) { toast.error("Please describe what you saw."); return; }
    setSaving(true);
    try {
      const { data } = await api.post(`/works/${work.id}/report`, { reason: reason.trim() });
      toast.success(data.flagged ? "Reported. This work has been hidden pending review." : "Reported. Thank you for keeping the archive safe.");
      onClose();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center bg-black/70 backdrop-blur-sm p-4" onClick={onClose} data-testid="report-modal">
      <div className="relative w-full max-w-md bg-[#161412] border border-[rgba(140,58,52,0.4)] rounded-sm p-6 sm:p-8" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 text-[#6E675E] hover:text-[#F7F3EC]" data-testid="report-close">
          <X className="w-5 h-5" />
        </button>
        <div className="flex items-center gap-2 mb-2">
          <Flag className="w-4 h-4 text-[#8C3A34]" />
          <div className="font-mono-brass text-xs uppercase tracking-widest text-[#8C3A34]">Report this work</div>
        </div>
        <h3 className="font-serif-display text-2xl text-[#F7F3EC] mb-1">Something isn't right?</h3>
        <p className="text-sm text-[#A8A095] mb-5 font-serif-body italic">Tell us in a sentence or two. Reports are anonymous to the author. Three reports auto-hide a work.</p>
        <form onSubmit={submit} className="space-y-4">
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={4}
            maxLength={500}
            required
            minLength={5}
            placeholder="e.g. This appears to sexualise a minor. / This is stolen from another author."
            className="w-full bg-[#0D0C0A] border border-[rgba(140,58,52,0.3)] focus:border-[#8C3A34] outline-none rounded-sm px-4 py-3 text-[#F7F3EC] font-serif-body text-base resize-none"
            data-testid="report-reason"
          />
          <button type="submit" disabled={saving} className="btn-buy w-full rounded-sm py-3.5 font-mono-brass text-xs uppercase tracking-widest font-semibold" data-testid="report-submit">
            {saving ? "Sending…" : "Send report"}
          </button>
        </form>
      </div>
    </div>
  );
}
